<template v-if="isModerator">
  <v-app>
    <v-app-bar
        app
        clipped-right
        color="blue-grey"
        dark
    >
      <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
      <v-toolbar-title>{{ $t('revizorLayout.appBar.title') }}</v-toolbar-title>
      <v-spacer></v-spacer>
      <div class="white--text mr-5" v-if="this.$store.getters.appLogin">{{ $t('revizorLayout.appBar.identifier') }}: {{ this.$store.getters.appLogin.id}}</div>

      <v-btn small color="primary_button" class="black--text" @click="onLogoutClicked">{{ $t('revizorLayout.appBar.logoutBtn') }}</v-btn>
    </v-app-bar>

    <v-navigation-drawer
        v-model="drawer"
        app
        :width="350"
    >
      <v-list dense>
        <v-list-item :to="{name: 'dashboard'}">
          <v-list-item-action>
            <v-icon>mdi-home</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>{{ $t('revizorLayout.navDrawer.home') }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-divider inset></v-divider>

        <v-list-item :to="{name: 'revizor-client-statistics'}">
          <v-list-item-action>
            <v-icon>mdi-format-list-checks</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>{{ $t('revizorLayout.navDrawer.statsByRegionForClients') }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item :to="{name: 'revizor-client-unit-statistics'}">
          <v-list-item-action>
            <v-icon>mdi-format-list-checks</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>{{ $t('revizorLayout.navDrawer.statsByClientBranches') }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>

    <v-main>
      <v-container fluid>
        <router-view v-if="$store.getters.appIsInitialized"/>
      </v-container>
    </v-main>

    <v-overlay :value="$store.getters.layoutIsLoading || !$store.getters.appIsInitialized">
      <v-progress-circular class="d-block" indeterminate size="64"></v-progress-circular>
      <v-btn style="margin: 10px 0 0 -30px" @click="onCancelClicked">{{ $t('revizorLayout.overlay.cancelBtn') }}</v-btn>
    </v-overlay>
  </v-app>
</template>

<script>
import {APP_INITIALIZE} from "@/store/modules/app/actions";
import {AUTH_LOGOUT} from "@/store/modules/auth/actions";
import {APP_INITIALIZE_FAILED} from "@/events/app";
import {Admin, Moderator, Monitoring} from "@/enums/user.type";
import AdminRegistyPermissionService from "@/services/admin.registy.permission.service";
import AdminTemplateService from "@/services/admin.template.service";
import AreaService from "@/services/area.service";
import AuthService from "@/services/auth.service";
import BalanceService from "@/services/balance.service";
import BranchService from "@/services/branch.service";
import ClientService from "@/services/client.service";
import GlobalOrganizationService from "@/services/global.organization.service";
import GlobalUnitService from "@/services/global.unit.service";
import GlobalUserService from "@/services/global.user.service";
import GlobalUserUnitPermissionService from "@/services/global.user.unit.permission.service.";
import MailCreateService from "@/services/mail.create.service";
import MailTrackingService from "@/services/mail.tracking.service";
import MailService from "@/services/mail.service";
import OrganizationService from "@/services/organization.service";
import RegionService from "@/services/region.service";
import RegistryService from "@/services/registry.service";
import StatisticsService from "@/services/statistics.service";
import TemplateService from "@/services/template.service";
import UnitService from "@/services/unit.service";
import UserService from "@/services/user.service";
import RegistryPermissionService from "@/services/registry.permission.service";

export default {
  name: "RevizorLayout",
  data: () => ({
    drawer: true,
    left: false,
  }),
  methods: {
    onCancelClicked(){
      AdminRegistyPermissionService.cancelRequests();
      AdminTemplateService.cancelRequests();
      AreaService.cancelRequests();
      AuthService.cancelRequests();
      BalanceService.cancelRequests();
      BranchService.cancelRequests();
      ClientService.cancelRequests();
      GlobalOrganizationService.cancelRequests();
      GlobalUnitService.cancelRequests();
      GlobalUserService.cancelRequests();
      GlobalUserUnitPermissionService.cancelRequests();
      MailCreateService.cancelRequests();
      MailTrackingService.cancelRequests();
      MailService.cancelRequests();
      OrganizationService.cancelRequests();
      RegionService.cancelRequests();
      RegistryService.cancelRequests();
      StatisticsService.cancelRequests();
      TemplateService.cancelRequests();
      UnitService.cancelRequests();
      UserService.cancelRequests();
      RegistryPermissionService.cancelRequests()
    },
    onLogoutClicked() {
      this.$store.dispatch(AUTH_LOGOUT)
    },
    onLogout() {
      this.$router.push({name: 'login'})
    },
    onAppInitializationFailed() {
      this.$store.dispatch(AUTH_LOGOUT)
      this.$router.push({name: 'login'})
    },
  },
  computed: {
    isAdmin() {
      return this.$store.getters.appIsInitialized && this.$store.getters.appLogin?.type === Admin;
    },
    isModerator() {
      return this.$store.getters.appIsInitialized && this.$store.getters.appLogin?.type === Moderator;
    },
    isMonitoring() {
      return this.$store.getters.appIsInitialized && this.$store.getters.appLogin?.type === Monitoring;
    },
    isModeratorUnitIsHead() {
      return this.$store.getters.appIsInitialized && this.$store.getters.appLogin?.type === Moderator && this.$store.getters.appLogin.unit.isHead;
    }
  },
  created() {
    this.$store.dispatch(APP_INITIALIZE)

    this.$bus.$on(AUTH_LOGOUT, this.onLogout)
    this.$bus.$on(APP_INITIALIZE_FAILED, this.onAppInitializationFailed)
  },
  beforeDestroy() {
    this.$bus.$off(AUTH_LOGOUT, this.onLogout)
    this.$bus.$off(APP_INITIALIZE_FAILED, this.onAppInitializationFailed)
  }
}
</script>

<style scoped>

</style>